import { makeStyles, alpha } from '@material-ui/core/styles';
const FONT_COLOR = '#565656';
const useclasses = makeStyles((theme) => ({
    scrollPaper: { top: 0, alignItems: 'center' },
    dialogContent: {
        overflowX: 'hidden',
        borderRadius: 8,
        padding: '0 !important'
    },
    img: {
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    },
    closeBtnWrapper: { position: 'absolute', top: 16, right: 16 },
    closeBtn: {
        width: 32,
        height: 32,
        backgroundColor: `${alpha(theme.palette.common.black, 0.3)} !important`,
        color: `${theme.palette.common.white} !important`
    },
    leftCol: { padding: '30px 40px 30px 40px' },
    textHeader: {
        color: FONT_COLOR,
        fontSize: '20px !important',
        marginBottom: '8px !important',
        fontWeight: `${theme.typography.fontWeightMedium}!important`
    },
    textDescription: {
        color: FONT_COLOR,
        fontSize: '14px !important',
        marginBottom: '17px !important'
    },
    textTitle: {
        color: FONT_COLOR,
        letterSpacing: '0 !important',
        marginBottom: '10px !important',
        fontWeight: `${theme.typography.fontWeightMedium}!important`
    },
    itemListWrapper: { display: 'flex', alignItems: 'center' },
    listText: { color: FONT_COLOR, fontSize: '14px !important' },
    listIcon: { width: 20, height: 20, marginRight: 20 },
    ctaIcon: { width: 16, height: 16 },
    ctaButton: {
        fontSize: 14,
        textTransform: 'inherit',
        height: 48,
        borderRadius: 8,
        marginTop: 20
    },
    ctaButtonCustom: {
        fontSize: 14,
        textTransform: 'inherit',
        height: 48,
        borderRadius: 8,
        marginTop: 20
    },
    checkIcon: { marginLeft: 10, marginRight: 20 },
    divMb: { marginBottom: 20 },
    root: { zIndex: 2000 }
}));
export default useclasses;
//# sourceMappingURL=WallModal.style.js.map